/*
# -----------------------------------------------------------------------------
# Component: receiptsFilterMixin.js
# Author: antonio.ramirez@pst.sg
# Created Date: 06/May/2019
# Comments: Responsible for all search filter functionality for Manage Receipts
# -----------------------------------------------------------------------------
*/
export const receiptsFilterMixin = {
  data() {
    return {
      branches: [],
      showAcctNoHelpList: false,
      showDocNoHelpList: false,
      showCurrHelpList: false,
      receiptsForm: {
        branch: null,
        accountNo: null,
        documentNo: null,
        transactionType: null,
        fund: null,
        transactionDate: null,
        transactionDateFrom: null,
        transactionDateTo: null,
        currency: null,
        actionName: null
      },
      receiptsFormLabel: {
        branch: 'Branch',
        accountNo: 'Account No.',
        documentNo: 'Document No.',
        transactionType: 'Transaction Type',
        fund: 'Fund',
        transactionDate: 'Transaction Date',
        transactionDateFrom: 'Transaction Date From',
        transactionDateTo: 'Transaction Date To',
        currency: 'Currency'
      }
    }
  },
  methods: {
    doClearRcpFilters() {
      var thisPage = this
      this.defaultFilter = {}

      // Iterate through each object field, key is name of the object field
      Object.keys(this.receiptsForm).forEach(function(key, index) {
        thisPage.receiptsForm[key] = ''
      })
      this.performSearch()
    },
    doRcpFilters() {
      this.resetMessages()
      this.$validator.validateAll('receiptsFilterForm').then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.performSearch()
        }
      })
    }
  }
}
